import { locationMapping } from '@/components/api/registrationApi/redirectUrl'
import { fetchRegistration } from '@/components/api/registrationApi'
import { SERVICE_TYPES, type ServiceType } from '@/components/constants'
import { calculateMD5 } from '@/components/utils/securityUtils'

interface FormData {
    workingStatus: string
    experienceYears: string
    prefecture: string
    lastName: string
    firstName: string
    age: string
    email: string
    phone: string
    lineId: string
    preferLineContact: boolean
    agreeTerms: boolean
    [key: string]: unknown
}

export const createRedirectUrl = (formData: FormData, registerToken: string, service: ServiceType = SERVICE_TYPES.FOODSLABO): string => {
    const prefecture = formData.prefecture
    const origin = window.location.origin

    const redirectPath = service === SERVICE_TYPES.HOTELSLABO ? '/hotels/thanks' : '/foodslabo/thanks'
    const location = locationMapping[prefecture] || 'online'
    const params = new URLSearchParams(window.location.search)
    params.set('location', location)
    params.set('register_token', registerToken)
    
    if (formData.phone) {
        const phoneHash = calculateMD5(formData.phone)
        if (phoneHash) {
            params.set('m', phoneHash)
        }
    }
    
    return `${origin}${redirectPath}?${params.toString()}`
}


let isSubmissionInFlight = false

// DEV-3129: 二重タップ防止のため、送信〜遷移完了までisSubmitting/isSubmissionInFlightを
// 意図的にfinallyで戻さない（戻すと遷移前に一瞬disabledが解除され連打で多重送信されうる）。
// 既知のトレードオフ: 遷移が完了せず同一ページに留まった場合（bfcacheでの戻る操作など）は
// ボタンが再操作不能のまま残る。ただし失敗時もthanksへ遷移する仕様上ユーザーは失敗を認識
// できず、意図的に戻って再送信を試みる動機がほぼ無いため実害は小さいと判断し許容している。
export const handleFormSubmission = async (
    e: React.FormEvent<HTMLFormElement>,
    formData: FormData,
    registerToken: string,
    setIsSubmitting: (value: boolean) => void,
    service: ServiceType = SERVICE_TYPES.FOODSLABO
): Promise<void> => {
    e.preventDefault()

    if (isSubmissionInFlight) {
        return
    }
    isSubmissionInFlight = true
    setIsSubmitting(true)

    try {
        let actualRegisterToken = registerToken
        try {
            const response = await fetchRegistration(formData, service)
            if (response.job_seeker?.register_token) {
                actualRegisterToken = response.job_seeker.register_token
            }
        } catch (apiError: unknown) {
            console.error('バックエンドAPI呼び出しエラー:', apiError instanceof Error ? apiError.message : String(apiError))
        }

        const redirectUrl = createRedirectUrl(formData, actualRegisterToken, service)

        try {
            localStorage.setItem('redirectAfterSubmit', redirectUrl)
        } catch (e) {
            console.error('localStorage設定エラー:', e)
        }

        window.location.href = redirectUrl
        // ページ遷移が始まったら押し込み状態を維持したままにする（isSubmittingは戻さない）
    } catch (error: unknown) {
        console.error('送信に失敗:', error instanceof Error ? error.message : String(error))

        try {
            const fallbackRedirectUrl = createRedirectUrl(formData, registerToken, service)
            window.location.href = fallbackRedirectUrl
            // こちらも遷移が始まるため押し込み状態を維持
        } catch (redirectError) {
            console.error('リダイレクト失敗:', redirectError)
            // 遷移自体が失敗し、ユーザーがこの画面に留まる場合のみボタンを再度操作可能にする
            setIsSubmitting(false)
            isSubmissionInFlight = false
        }
    }
}
